import styled from 'styled-components'

function Technology({ color, icon, name, type, useCase, isLoading }) {
  return (
    <Container>
      {isLoading
        ? (
            <Skeleton />
          )
        : (
            <>
              <Head $color={color}>
                <img
                  src={icon}
                  alt="logo"
                />
              </Head>
              <Column $forceWidth={110}>
                <h2>name</h2>
                <p>{name}</p>
              </Column>
              <Column $forceWidth={200}>
                <h2>type</h2>
                <p>{type}</p>
              </Column>
              <Column $noBorder>
                <h2>use case</h2>
                <p>{useCase}</p>
              </Column>
            </>
          )}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100px;
  border: 1px solid hsl(var(--primary-800));
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 1rem;

  @media (max-width: 850px) {
    flex-direction: column;
    height: auto;
  }

  &:hover {
    background-color: hsl(var(--primary-800));
  }
`

const Head = styled.div`
  height: 100%;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  fill: #fff;
  background-color: ${({ $color }) => $color};
  flex-shrink: 0;

  @media (max-width: 850px) {
    height: 50px;
    width: 100%;
  }

  img {
    height: 30px;
    width: 30px;
  }
`

const Column = styled.div`
  display: block;
  height: 100%;
  width: ${({ $forceWidth }) =>
    $forceWidth ? `${$forceWidth}px` : 'fit-content'};
  min-width: ${({ $forceWidth }) =>
    $forceWidth ? `${$forceWidth}px` : undefined};
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-right: 1px solid
    ${({ $noBorder }) => ($noBorder ? 'transparent' : 'hsl(var(--primary-800))')};
  padding: 1rem;
  box-sizing: border-box;
  flex-shrink: ${({ $noBorder }) => ($noBorder ? undefined : 0)};

  @media (max-width: 850px) {
    height: 50px;
    width: 100%;
    border-bottom: 1px solid
      ${({ $noBorder }) =>
        $noBorder ? 'transparent' : 'hsl(var(--primary-800))'};
    padding: 1rem;
    flex-shrink: 0;
    box-sizing: content-box;
  }

  h2 {
    font-family: "Courier New";
    margin: 0;
    color: #fff;
    font-size: 14px;
  }

  p {
    margin: 0;
    white-space: normal;
  }
`
const Skeleton = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100px;
  border: 1px solid hsl(var(--primary-800));
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 1rem;

  @media (max-width: 850px) {
    flex-direction: column;
    height: auto;
  }

  &:hover {
    background-color: hsl(var(--primary-800));
  }
  animation: skeletonAnimation 1s ease-in-out infinite alternate;

  @keyframes skeletonAnimation {
    0% {
      opacity: 0.6;
      background-color: rgb(78, 78, 78);
    }
    100% {
      opacity: 1;
      background-color: #171717;
    }
  }
`
export default Technology
